const isIos = () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return true;
  }
  return false;
};

export default isIos;
